import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

const FORMATS = [
  { value: '3:4', label: '3:4', orientation: 'Portrait', width: 54, height: 72 },
  { value: '9:16', label: '9:16', orientation: 'Portrait', width: 45, height: 80 },
  { value: '4:3', label: '4:3', orientation: 'Landscape', width: 80, height: 60 },
  { value: '16:9', label: '16:9', orientation: 'Landscape', width: 88, height: 50 },
];

const STYLES = [
  { value: 'premium', title: 'Option 1', description: 'Premium sections' },
  { value: 'grid', title: 'Option 2', description: 'Directory grid' },
  { value: 'sidebar', title: 'Option 3', description: 'Floor sidebar' },
];

export default function DirectoryFormatPicker({
  onSelect, disabled = false, activeFormat = '', directoryStyle = 'premium', onStyleChange,
}) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Box>
        <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1 }}>Directory style</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
          {STYLES.map(style => (
            <Button
              key={style.value}
              variant={directoryStyle === style.value ? 'contained' : 'outlined'}
              disabled={disabled}
              onClick={() => onStyleChange?.(style.value)}
              sx={{ minHeight: 72, display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}
            >
              <Typography fontWeight={800}>{style.title}</Typography>
              <Typography variant="caption" sx={{ opacity: .85 }}>{style.description}</Typography>
            </Button>
          ))}
        </Box>
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1 }}>Screen format</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' }, gap: 1.5 }}>
        {FORMATS.map(format => {
        const active = activeFormat === format.value;
        return (
          <Button
            key={format.value}
            variant="outlined"
            disabled={disabled}
            onClick={() => onSelect(format.value)}
            sx={{
              minHeight: 150,
              p: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              borderWidth: active ? 2 : 1,
            }}
          >
            <Box sx={{ height: 82, display: 'grid', placeItems: 'center' }}>
              {active ? (
                <CircularProgress size={34} />
              ) : (
                <Box sx={{
                  width: format.width,
                  height: format.height,
                  maxWidth: '100%',
                  border: '2px solid',
                  borderColor: 'primary.main',
                  borderRadius: 1,
                  background: 'linear-gradient(145deg, rgba(25,118,210,.18), rgba(25,118,210,.04))',
                  boxShadow: 'inset 0 0 0 4px rgba(255,255,255,.65)',
                }} />
              )}
            </Box>
            <Typography fontWeight={800}>{format.label}</Typography>
            <Typography variant="caption" color="text.secondary">{format.orientation}</Typography>
          </Button>
        );
        })}
        </Box>
      </Box>
    </Box>
  );
}
